export default "__VITE_ASSET__76d45482__"